import { render } from "./vagentordermony.vue?vue&type=template&id=a20d764a&scoped=true"
import script from "./vagentordermony.vue?vue&type=script&lang=js"
export * from "./vagentordermony.vue?vue&type=script&lang=js"

import "./vagentordermony.vue?vue&type=style&index=0&id=a20d764a&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境商户后台shop.jsyinba.com/jsmerchant/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a20d764a"]])

export default __exports__